const S = {
  " ": [2, 1, 2, 2, 2, 2],
  "!": [2, 2, 2, 1, 2, 2],
  '"': [2, 2, 2, 2, 2, 1],
  "#": [1, 2, 1, 2, 2, 3],
  $: [1, 2, 1, 3, 2, 2],
  "%": [1, 3, 1, 2, 2, 2],
  "&": [1, 2, 2, 2, 1, 3],
  "'": [1, 2, 2, 3, 1, 2],
  "(": [1, 3, 2, 2, 1, 2],
  ")": [2, 2, 1, 2, 1, 3],
  "*": [2, 2, 1, 3, 1, 2],
  "+": [2, 3, 1, 2, 1, 2],
  ",": [1, 1, 2, 2, 3, 2],
  "-": [1, 2, 2, 1, 3, 2],
  ".": [1, 2, 2, 2, 3, 1],
  "/": [1, 1, 3, 2, 2, 2],
  0: [1, 2, 3, 1, 2, 2],
  1: [1, 2, 3, 2, 2, 1],
  2: [2, 2, 3, 2, 1, 1],
  3: [2, 2, 1, 1, 3, 2],
  4: [2, 2, 1, 2, 3, 1],
  5: [2, 1, 3, 2, 1, 2],
  6: [2, 2, 3, 1, 1, 2],
  7: [3, 1, 2, 1, 3, 1],
  8: [3, 1, 1, 2, 2, 2],
  9: [3, 2, 1, 1, 2, 2],
  ":": [3, 2, 1, 2, 2, 1],
  ";": [3, 1, 2, 2, 1, 2],
  "<": [3, 2, 2, 1, 1, 2],
  "=": [3, 2, 2, 2, 1, 1],
  ">": [2, 1, 2, 1, 2, 3],
  "?": [2, 1, 2, 3, 2, 1],
  "@": [2, 3, 2, 1, 2, 1],
  A: [1, 1, 1, 3, 2, 3],
  B: [1, 3, 1, 1, 2, 3],
  C: [1, 3, 1, 3, 2, 1],
  D: [1, 1, 2, 3, 1, 3],
  E: [1, 3, 2, 1, 1, 3],
  F: [1, 3, 2, 3, 1, 1],
  G: [2, 1, 1, 3, 1, 3],
  H: [2, 3, 1, 1, 1, 3],
  I: [2, 3, 1, 3, 1, 1],
  J: [1, 1, 2, 1, 3, 3],
  K: [1, 1, 2, 3, 3, 1],
  L: [1, 3, 2, 1, 3, 1],
  M: [1, 1, 3, 1, 2, 3],
  N: [1, 1, 3, 3, 2, 1],
  O: [1, 3, 3, 1, 2, 1],
  P: [3, 1, 3, 1, 2, 1],
  Q: [2, 1, 1, 3, 3, 1],
  R: [2, 3, 1, 1, 3, 1],
  S: [2, 1, 3, 1, 1, 3],
  T: [2, 1, 3, 3, 1, 1],
  U: [2, 1, 3, 1, 3, 1],
  V: [3, 1, 1, 1, 2, 3],
  W: [3, 1, 1, 3, 2, 1],
  X: [3, 3, 1, 1, 2, 1],
  Y: [3, 1, 2, 1, 1, 3],
  Z: [3, 1, 2, 3, 1, 1],
  "[": [3, 3, 2, 1, 1, 1],
  "\\": [3, 1, 4, 1, 1, 1],
  "]": [2, 2, 1, 4, 1, 1],
  "^": [4, 3, 1, 1, 1, 1],
  _: [1, 1, 1, 2, 2, 4],
  NUL: [1, 1, 1, 4, 2, 2],
  SOH: [1, 2, 1, 1, 2, 4],
  STX: [1, 2, 1, 4, 2, 1],
  ETX: [1, 4, 1, 1, 2, 2],
  EOT: [1, 4, 1, 2, 2, 1],
  ENQ: [1, 1, 2, 2, 1, 4],
  ACK: [1, 1, 2, 4, 1, 2],
  BEL: [1, 2, 2, 1, 1, 4],
  BS: [1, 2, 2, 4, 1, 1],
  HT: [1, 4, 2, 1, 1, 2],
  LF: [1, 4, 2, 2, 1, 1],
  VT: [2, 4, 1, 2, 1, 1],
  FF: [2, 2, 1, 1, 1, 4],
  CR: [4, 1, 3, 1, 1, 1],
  SO: [1, 1, 1, 2, 4, 2],
  SI: [1, 2, 1, 1, 4, 2],
  DLE: [1, 2, 1, 2, 4, 1],
  DC1: [1, 1, 4, 2, 1, 2],
  DC2: [1, 2, 4, 1, 1, 2],
  DC3: [1, 2, 4, 2, 1, 1],
  DC4: [4, 1, 1, 2, 1, 2],
  NAK: [4, 2, 1, 1, 1, 2],
  SYN: [4, 2, 1, 2, 1, 1],
  ETB: [2, 1, 2, 1, 4, 1],
  CAN: [2, 1, 4, 1, 2, 1],
  EM: [4, 1, 2, 1, 2, 1],
  SUB: [1, 1, 1, 1, 4, 3],
  ESC: [1, 1, 1, 3, 4, 1],
  FS: [1, 3, 1, 1, 4, 1],
  GS: [1, 1, 4, 1, 1, 3],
  RS: [1, 1, 4, 3, 1, 1],
  US: [4, 1, 1, 1, 1, 3],
  FNC_3: [4, 1, 1, 3, 1, 1],
  FNC_2: [1, 1, 3, 1, 4, 1],
  SHIFT: [1, 1, 4, 1, 3, 1],
  Code_C: [4, 1, 1, 1, 3, 1],
  Code_B: [2, 1, 1, 4, 1, 2],
  FNC_4: [2, 1, 1, 2, 1, 4],
  FNC_1: [4, 1, 2, 1, 1, 2],
  START_A: [2, 1, 1, 4, 1, 2],
  START_B: [2, 1, 1, 2, 1, 4],
  START_C: [2, 1, 1, 2, 3, 2],
  STOP: [2, 3, 3, 1, 1, 1, 2]
};
export {
  S as code128Table
};
